"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RaidOnPrivateers = void 0;
const GlobalEventName_1 = require("../GlobalEventName");
const PartyName_1 = require("../../parties/PartyName");
const Resources_1 = require("../../../Resources");
const Tags_1 = require("../../../cards/Tags");
class RaidOnPrivateers {
    constructor() {
        this.name = GlobalEventName_1.GlobalEventName.RAID_ON_PRIVATEERS;
        this.description = 'Lose 5 M€ if you have 4 or more planetary tags, reduced by influence.';
        this.revealedDelegate = PartyName_1.PartyName.POPULISTS;
        this.currentDelegate = PartyName_1.PartyName.CENTRISTS;
    }
    resolve(game, turmoil) {
        game.getPlayers().forEach((player) => {
            const planetaryTagCount = player.getTagCount(Tags_1.Tags.VENUS, 'raw') + player.getTagCount(Tags_1.Tags.EARTH, 'raw') + player.getTagCount(Tags_1.Tags.JOVIAN, 'raw');
            const amount = planetaryTagCount - turmoil.getPlayerInfluence(player);
            if (amount >= 4)
                player.deductResource(Resources_1.Resources.MEGACREDITS, 5, { log: true });
        });
    }
}
exports.RaidOnPrivateers = RaidOnPrivateers;
//# sourceMappingURL=RaidOnPrivateers.js.map